module.exports = __webpack_public_path__ + "static/media/adminDashboardGreen.c217ddd9.svg";